import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BlogHeader from './components/BlogHeader';
import BlogGrid from './components/BlogGrid';
import NewsletterForm from './components/NewsletterForm';
import BlogCTA from './components/BlogCTA';

export default function BlogPage() {
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <div className="min-h-screen bg-background-200">
      <Navbar dark />
      <main className="flex flex-col">
        <BlogHeader
          searchQuery={searchQuery}
          onSearchChange={setSearchQuery}
        />
        <BlogGrid searchQuery={searchQuery} />
        <NewsletterForm />
        <BlogCTA />
      </main>
      <Footer />
    </div>
  );
}